import { useSearchParams } from 'react-router-dom';

export const useShouldDisplayLogin = () => {
  const [searchParams] = useSearchParams();

  const shouldDisplayLogin = searchParams.get('sessionId') === null;

  return { shouldDisplayLogin };
};
